import { apiClient } from '~/shared/api/data-ingestion-api'
import { splitDocumentPageRanges } from './split-document-page-ranges'
import { type DocumentPageRange } from './types'
import { unsplitDocumentPageRanges } from './unsplit-document-page-ranges'

export function moveDocumentPageRanges({
  documents,
  currentDocumentPageRanges,
  splitFromIndex,
  splitToIndex,
}: {
  documents: apiClient.Document[]
  currentDocumentPageRanges: DocumentPageRange[]
  splitFromIndex: number
  splitToIndex: number
}) {
  const documentId = currentDocumentPageRanges.find(
    (documentPageRange) =>
      documentPageRange.pageRange.startPage <= splitFromIndex &&
      documentPageRange.pageRange.endPage >= splitFromIndex,
  )?.documentId
  if (!documentId) {
    return []
  }
  const unsplitRanges = unsplitDocumentPageRanges({
    documents,
    currentDocumentPageRanges,
    documentId,
    unsplitIndex: splitFromIndex,
  })
  const newDocumentId = unsplitRanges.find(
    (documentPageRange) =>
      documentPageRange.pageRange.startPage <= splitToIndex &&
      documentPageRange.pageRange.endPage >= splitToIndex,
  )?.documentId
  if (!newDocumentId) {
    return []
  }
  return splitDocumentPageRanges({
    documents,
    currentDocumentPageRanges: unsplitRanges,
    documentId: newDocumentId,
    splitIndex: splitToIndex,
  })
}
